import React, { useEffect, useRef } from 'react';
import './homepage.css';

const TopicSection = () => {
  const topicCardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = Array.from(topicCardsRef.current).reverse();

            cards.forEach((card, index) => {
              setTimeout(() => {
                if (card) {
                  card.classList.add('visible');
                }
              }, index * 300);
            });

            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 } // Trigger when 30% of the section is visible
    );

    if (topicCardsRef.current.length > 0) {
      observer.observe(document.querySelector('.topics-display'));
    }

    return () => {
      if (observer) observer.disconnect();
    };
  }, []);

  return (
    <section className="topics-section page-width px-3 my-5 py-5">
      <h2 className="text-center text-uppercase pt-5 pb-5 mt-5">
        OUR CONVERSATIONS THIS YEAR WILL BE ON
      </h2>

      <section className="topics-display my-5">
        <div className="topic-card topic-card1" ref={(el) => (topicCardsRef.current[2] = el)}>
          <p>The Gatekeepers of innovation</p>
        </div>
        <div className="topic-card topic-card2" ref={(el) => (topicCardsRef.current[0] = el)}>
          <p>Designing for nation building</p>
        </div>
        <div className="topic-card topic-card3" ref={(el) => (topicCardsRef.current[1] = el)}>
          <p>the creators mindset</p>
        </div>
        <div className="topic-card topic-card4" ref={(el) => (topicCardsRef.current[3] = el)}>
          <p>Designing family</p>
        </div>
        <div className="topic-card topic-card5" ref={(el) => (topicCardsRef.current[7] = el)}>
          <p>Designing media</p>
        </div>
        <div className="topic-card topic-card6" ref={(el) => (topicCardsRef.current[5] = el)}>
          <p>Designing government</p>
        </div>
        <div className="topic-card topic-card7" ref={(el) => (topicCardsRef.current[4] = el)}>
          <p>Designing business</p>
        </div>
        <div className="topic-card topic-card8" ref={(el) => (topicCardsRef.current[6] = el)}>
          <p>Designing entertainment</p>
        </div>
        <div className="topic-card topic-card9" ref={(el) => (topicCardsRef.current[8] = el)}>
          <p>Designing church</p>
        </div>
      </section>
    </section>
  );
};

export default TopicSection;
